/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { Component } from '@angular/core';

@Component({
  selector: 'nb-bootstrap-test',
  styles: [
    ``,
  ],
  template: `
        <h2>Buttons</h2>
        <div class="container">
        <div class="row">
        <div class="col-md-5">
        <div class="card">
          <div class="card-block">
            This is some text within a card block.
            <span class="badge badge-default">Default</span>
            <span class="badge badge-primary">Primary</span>
            <span class="badge badge-success">Success</span>
            <span class="badge badge-info">Info</span>
            <span class="badge badge-warning">Warning</span>
            <span class="badge badge-danger">Danger</span>
          </div>
        </div>
          <button class="btn btn-sm btn-primary btn-rectangle">Primary</button>
          <button class="btn btn-sm btn-secondary">Secondary</button>
          </div>
          <div class="col-md-5">
          <button class="btn btn-hero btn-info">Info</button>
          <button class="btn btn-md btn-danger">Danger</button>
          </div>
        </div>
        <div class="row">
        <div class="col-md-1">
          <button class="btn btn-md btn-success">Success</button>
          <button class="btn btn-sm btn-warning">Warning</button>
          <button type="button" class="btn btn-outline-primary">Primary</button>
          <button type="button" class="btn btn-outline-secondary">Secondary</button>
          <button type="button" class="btn btn-outline-success">Success</button>
          <button type="button" class="btn btn-outline-info">Info</button>
          <button type="button" class="btn btn-outline-warning">Warning</button>
          <button type="button" class="btn btn-outline-danger">Danger</button>

          </div>
        </div>
        <h2>Tables</h2>
        <table class="table table-striped">
          <thead>
            <tr>
              <td>id</td>
              <td>name</td>
              <td>email</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>some</td>
              <td>John Doe</td>
              <td>test@test.com</td>
            </tr>
            <tr>
              <td>some</td>
              <td>John Doe</td>
              <td>test@test.com</td>
            </tr>
            <tr>
              <td>some</td>
              <td>John Doe</td>
              <td>test@test.com</td>
            </tr>
            <tr>
              <td>some</td>
              <td>John Doe</td>
              <td>test@test.com</td>
            </tr>
          </tbody>
        </table>
  `,
})
export class NbBootstrapTestComponent {

}



// WEBPACK FOOTER //
// ./src/app/bootstrap-test/bootstrap-test.component.ts